import type { ElementType, FC, HTMLAttributes, ReactNode } from 'react'

import PixelText from '@/components/motion/pixel-text'

interface SplitWordsProps extends HTMLAttributes<HTMLElement> {
    as?: ElementType
    text: string
    /** 'load' plays on first paint, 'view' plays when scrolled into view. */
    mode?: 'load' | 'view'
    /** Kept for existing call sites; every heading now resolves letter by letter. */
    by?: 'word' | 'letter'
    /** Delay in milliseconds before the first letter starts. */
    delay?: number
}

/**
 * Section and page headings. Every heading resolves out of square pixels
 * through PixelText, so all existing call sites share one site-wide reveal.
 */
const SplitWords: FC<SplitWordsProps> = ({ by: _by, ...props }): ReactNode => {
    return <PixelText {...props} />
}

export default SplitWords
